const Backbone = require('backbone');
const VideoView = require('app/views/store/common/video');
const VideosView = Backbone.View.extend({
	initialize: function(options) {
		this.parentView = options.parentView;
		this.$videos = this.$('.js-deferable-video');
		this._initializeVideoViews();
	},
	_initializeVideoViews: function() {
		this.$videos.each((index, video) => {
			const $video = $(video);
			const videoView = new VideoView({ el: $video });
			$video.data('view', videoView);
		});
	}
});

module.exports = VideosView;
